import { render } from "./VpcTab.vue?vue&type=template&id=697e7d62&scoped=true"
import script from "./VpcTab.vue?vue&type=script&lang=js"
export * from "./VpcTab.vue?vue&type=script&lang=js"

import "./VpcTab.vue?vue&type=style&index=0&id=697e7d62&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.22.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-697e7d62"]])

export default __exports__